import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as Actions from "../store/actions";
const useLogout = () => {
    const { shop_id } = useParams();
    const dispatch = useDispatch();
    const handleLogout = () => {
        dispatch(
            Actions.authLogout({
                shop_id: shop_id,
            })
        );
    };
    return handleLogout
};

export default useLogout;
